export const search = 'Tìm kiếm';
